"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _Location = _interopRequireDefault(require("../../../../molecules/Location"));
var _SiteMap = _interopRequireDefault(require("../../../../molecules/SiteMap"));
var _HoursOfOperation = _interopRequireDefault(require("../../../../molecules/HoursOfOperation"));
require("./site-footer-body.css");
var SimpleBody = function SimpleBody(props) {
  var contactInformation = props.contactInformation,
    pages = props.pages,
    hours = props.hours,
    bodyColor = props.bodyColor,
    locationClassName = props.locationClassName,
    hoursClassName = props.hoursClassName,
    pagesClassName = props.pagesClassName;
  var contactInfoColumns = contactInformation !== null ? 3 : 0;
  var hoursColumns = hours.length !== 0 ? 3 : 0;
  var infoColumns = contactInfoColumns + hoursColumns > 0 ? 3 : 0;
  var pageColumns = 2;
  var InfoColumn = function InfoColumn() {
    return infoColumns < 3 ? null : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
      computer: infoColumns,
      tablet: infoColumns * 2,
      mobile: 16,
      floated: "right",
      textAlign: "center"
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
      as: "h4",
      className: "site-footer-body-header"
    }, "Contact Information"), /*#__PURE__*/_react["default"].createElement(_Location["default"], {
      address: contactInformation.address,
      showIcon: false,
      className: locationClassName
    }), hours && /*#__PURE__*/_react["default"].createElement("br", null), hours && /*#__PURE__*/_react["default"].createElement("br", null), hours && /*#__PURE__*/_react["default"].createElement(_HoursOfOperation["default"], {
      hours: hours,
      displayOption: "grouped",
      className: hoursClassName
    }));
  };
  var PagesColumn = function PagesColumn() {
    return pages.map(function (page) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: "footer-page-".concat(page.title)
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        mobile: 3,
        only: "mobile"
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        className: pagesClassName,
        computer: pageColumns,
        tablet: pageColumns,
        verticalAlign: "top",
        only: "computer tablet"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: "h4",
        className: "site-footer-body-header"
      }, page.title), /*#__PURE__*/_react["default"].createElement(_SiteMap["default"], {
        title: page.title,
        links: page.pages
      })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        className: pagesClassName,
        mobile: 10,
        verticalAlign: "middle",
        textAlign: "center",
        only: "mobile"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: "h4"
      }, page.title), /*#__PURE__*/_react["default"].createElement(_SiteMap["default"], {
        links: page.pages
      })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
        computer: 1,
        tablet: 1,
        mobile: 3
      }));
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: bodyColor,
      paddingTop: '3em',
      paddingBottom: '2em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: 1,
    tablet: 1,
    only: "computer"
  }), /*#__PURE__*/_react["default"].createElement(PagesColumn, null), /*#__PURE__*/_react["default"].createElement(InfoColumn, null), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: 1,
    only: "computer"
  })));
};
SimpleBody.propTypes = {
  pages: _propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].shape({
    pageTitle: _propTypes["default"].string.isRequired,
    slug: _propTypes["default"].string.isRequired,
    internal: _propTypes["default"].bool.isRequired
  }))).isRequired,
  contactInformation: _propTypes["default"].shape({
    address: _propTypes["default"].shape({
      street: _propTypes["default"].string.isRequired,
      city: _propTypes["default"].string.isRequired,
      state: _propTypes["default"].string.isRequired,
      zip: _propTypes["default"].string.isRequired
    }),
    phoneNumber: _propTypes["default"].string.isRequired,
    email: _propTypes["default"].string
  }),
  bodyColor: _propTypes["default"].string.isRequired,
  locationClassName: _propTypes["default"].string,
  hoursClassName: _propTypes["default"].string,
  pagesClassName: _propTypes["default"].string,
  hours: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    day: _propTypes["default"].number.isRequired,
    open: _propTypes["default"].number.isRequired,
    close: _propTypes["default"].number.isRequired,
    label: _propTypes["default"].string
  }))
};
SimpleBody.defaultProps = {
  contactInformation: null,
  hours: null,
  locationClassName: 'footer-location-info',
  hoursClassName: 'footer-hoo',
  pagesClassName: 'footer-pages'
};
var _default = SimpleBody;
exports["default"] = _default;